<div class="layout-base no-scrollbar relative flex flex-col shadow">
  <market-header></market-header>
  <ng-content></ng-content>
  <div class="bg-neutral-700 pb-[64px]">
    <app-footer></app-footer>
  </div>
  @if (isLogin$ | async) {
    <market-footer></market-footer>
  }
</div>
